import {Component, Inject} from '@angular/core';
import {MAT_SNACK_BAR_DATA} from '@angular/material';

@Component({
  selector: 'app-snackbar',
  template: '<div> <span class="snackbar-content">{{content}}</span> </div>'
})
export class AppSnackbarComponent {
  constructor( @Inject(MAT_SNACK_BAR_DATA) public content: any) { }
}



// WEBPACK FOOTER //
// ./src/app/helpers/app-snackbar.component.ts